var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showNPSPopup)?_c('Popup',{attrs:{"loading":_vm.submittingNPSScore},on:{"onSubmit":_vm.handleSubmit}}):(_vm.showNPSSuccess)?_c('Success',{attrs:{"type":_vm.successType},on:{"onClose":_vm.closeSuccessPopup}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }